import TableButton from "./TableButton.js";

// reactstrap components
import {
  Container,
  Row,
  Col,
  Button,
  Card, 
  CardBody,
  UncontrolledCollapse
} from "reactstrap";

// core components

function TableMap({toSheet, isFree, nbPers, isUPHF, tableChoice}) {

/*     const style = {
        display: "grid",
        gridTemplateColumns: "auto auto auto auto auto auto auto auto auto auto",
        backgroundColor: "#2196F3"
    } */

  return (
    <div id="table-map-section">
        <Container>
        <h6 className="title">Choisissez votre table selon les disponibilités (en cliquant dessus) :</h6>
        Si la carte interactive ne s'affiche pas correctement sur mobile, cliquez ici :&nbsp;
        <Button color="primary" id="mobile">
          Image du plan des tables pour les versions mobiles
        </Button>
{/*         <Button color="primary" id="ordi">
          Carte des tables pour les versions ordinateurs
        </Button> */}
        <UncontrolledCollapse toggler="#mobile">
          <Card >
            <CardBody style={{color: "black"}}>
                Si la carte interactive ne s'affiche pas correctement sur mobile, voici le plan exact en format image :
                <br/>(Cliquez ensuite sur la table verte correspondante après l'image)
                <br/> 
                <br/>
                <img
                  alt="..."
                  src={require("assets/img/plan-table.png").default}
                ></img>
                <br/>
                <br/>
                Lettres A-I : Lignes
                <br/>
                Chiffres 0-9 : Colonnes
            </CardBody>
          </Card>
        </UncontrolledCollapse>
        <Row>
          <h6 className="blockquote text-center" style={{marginTop: "1%", padding: "1vw", marginRight: "1vw"}}>
                <div style={{marginTop: "25vh", fontSize: "1.4vw"}}>Scène
                                                <br/>
                                                  Piste Danse 
                                                <br/>
                                                &amp; Bar </div>
            </h6>
            <Col>
            <Row>
                <TableButton id={"A"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/> 
            </Row>
            <Row>
                <TableButton id={"B"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"C"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"D"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"E"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"F"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"G"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"H"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            <Row>
                <TableButton id={"I"} isFree={isFree} toSheet={toSheet} nbPers={nbPers} isUPHF={isUPHF} tableChoice={tableChoice}/>
            </Row>
            </Col> 
{/*             <h6 className="blockquote text-center" style={{marginTop: "1%", padding: "1vw", margin: "0"}}>
                <div style={{marginTop: "5%", fontSize: "1.4vw"}}>Piste Danse 
                                                <br/>
                                                &amp; Bar
                </div>
            </h6> */}

          </Row>
        </Container>
    </div>
  );
}

export default TableMap;
